import script from "./ShopCategories.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopCategories.vue?vue&type=script&setup=true&lang=js"

import "./ShopCategories.vue?vue&type=style&index=0&id=76c87da8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76c87da8"]])

export default __exports__